<template>
  <div>
    <div class="form-group">
      <label for="exampleInputEmail1">{{ $t('duration') }}</label>
      <VueCtkDateTimePicker
        :label="$t('Choose Time And Date')"
        :button-now-translation="$t('now')"
        v-model="date"
        format="YYYY-MM-DD"
        formated="YYYY-MM-DD"
        color="#631263"
        button-color="#631263"
        locale="ar"
        :range="true"
        :onlyDate="true"
        :custom-shortcuts="[
          {
            key: 'thisWeek',
            label: $t('this Week'),
            value: 'isoWeek'
          },
          {
            key: 'lastWeek',
            label: $t('the Last Week'),
            value: '-isoWeek'
          },
          {
            key: 'last7Days',
            label: $t('the Last Days'),
            value: 7
          },
          {
            key: 'last30Days',
            label: $t('the Last 30Days'),
            value: 30
          },
          {
            key: 'this Month',
            label: $t('this Month'),
            value: 'month'
          },
          {
            key: 'last Month',
            label: $t('previous Month'),
            value: '-month'
          },
          {
            key: 'thisYear',
            label: $t('this Year'),
            value: 'year'
          },
          {
            key: 'lastYear',
            label: $t('last Year'),
            value: '-year'
          }
        ]"
      />
    </div>
  </div>
</template>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  data() {
    return {
      date: {
        start: this.withoutDate
          ? ''
          : new Date().toISOString('en-US', { timeZone: 'Africa/Cairo' }).slice(0, 10),
        end: ''
      }
    }
  },
  components: {
    VueCtkDateTimePicker
  },
  methods: {
    fixNumbers(str) {
      let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
      if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
          str = str.replace(arabicNumbers[i], i)
          str = str.replace('ص', 'am').replace('م', 'pm')
        }
      }
      return str
    }
  },
  watch: {
    date: function (val) {
      let firstDate = this.fixNumbers(val.start)
      let lastDate = this.fixNumbers(val.end)
      this.$parent.params.startDate = firstDate
      this.$parent.params.endDate = lastDate
    }
  },
  props: ['withoutDate']
}
</script>
